//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React, { ReactElement } from 'react'
import { Button, Tooltip, Typography, useTheme } from '@mui/material'

import AlarmIcon from '@mui/icons-material/Alarm'
import HourglassTopIcon from '@mui/icons-material/HourglassTop'
export type ButtonActionVariant = 'primary' | 'secondary' | 'tertiary'

export interface ButtonActionProps {
  'data-testid'?: string
  to?: string
  type?: 'submit' | 'reset' | 'button'
  component?: any
  onClick?: any
  disabled?: boolean
  children?: React.ReactNode
  isLateString?: string
  isEarlyString?: string
  isAnotherRoleString?: string
  variant: ButtonActionVariant
  sx?: any
  tooltip?: string
  startIcon?: ReactElement
}

export default function ButtonAction(props: ButtonActionProps): ReactElement {
  const theme = useTheme()
  const children = props.children
  const variant: ButtonActionVariant = props.variant
  const startIcon = props.startIcon
  const { isLateString, isEarlyString, isAnotherRoleString, tooltip } = props
  const filteredProps: any = { ...props }
  delete filteredProps.isLateString
  delete filteredProps.isEarlyString
  delete filteredProps.isAnotherRoleString
  let buttonVariant = 'contained'
  let sx = {
    ...props.sx,
    backgroundColor: theme.palette.fg.main,
    color: '#FFFFFF',
    padding: '8px 10px 8px 10px',
    borderRadius: '6px',
  }

  if (variant === 'tertiary') {
    buttonVariant = 'outlined'
    sx = {
      ...props.sx,
      color: theme.palette.fg.main,
      borderColor: theme.palette.fg.main,
      padding: '8px 10px 8px 10px',
      borderRadius: '6px',
    }
  }

  const endIcon = isLateString ? <AlarmIcon /> : isEarlyString ? <HourglassTopIcon /> : null

  // prettier-ignore
  /* eslint-disable prettier/prettier */
  const titleString = isAnotherRoleString
    ? `${isAnotherRoleString} ${isLateString ?? isEarlyString ?? ''}`
    : (isLateString ?? isEarlyString ?? '')

  return (
    <Tooltip title={tooltip ?? titleString} placement="bottom">
      <span>
        <Button
          disabled={!!props.disabled}
          {...filteredProps}
          sx={sx}
          variant={buttonVariant}
          startIcon={startIcon}
          endIcon={endIcon}
        >
          <Typography variant={'buttonBold'}>{children}</Typography>
        </Button>
      </span>
    </Tooltip>
  )
}
